
@if(isInAppBrowser()) {
  <div class="fixed inset-0 z-[9999] bg-slate-900/95 flex flex-col items-center justify-center p-6 text-center text-white backdrop-blur-sm">
      <div class="animate-bounce mb-6">
          <i class="fa-solid fa-arrow-up text-5xl text-emerald-400"></i>
      </div>
      <h2 class="text-2xl font-bold mb-4">กรุณาเปิดในเบราว์เซอร์ (Open in Browser)</h2>
      <p class="text-slate-300 mb-6 max-w-sm">
          เพื่อให้การลงทะเบียนและการล็อกอินผ่าน Google ทำงานได้อย่างสมบูรณ์ <br>
          กรุณากดที่ <strong>ปุ่มเมนูมุมขวาบน (จุด 3 จุด)</strong> <br>
          แล้วเลือก <strong>"เปิดในเบราว์เซอร์เริ่มต้น" (Open in external browser)</strong>
      </p>
      
      <div class="p-4 bg-slate-800 rounded-xl border border-slate-700 max-w-xs w-full">
          <div class="flex items-center gap-3 mb-2">
              <span class="w-6 h-6 rounded-full bg-slate-600 flex items-center justify-center text-xs">1</span>
              <span>กดที่มุมขวาบน <i class="fa-solid fa-ellipsis-vertical"></i></span>
          </div>
          <div class="flex items-center gap-3">
              <span class="w-6 h-6 rounded-full bg-slate-600 flex items-center justify-center text-xs">2</span>
              <span>เลือก <strong>Open in Browser</strong> <i class="fa-brands fa-safari"></i> <i class="fa-brands fa-chrome"></i></span>
          </div>
      </div>

      <button (click)="closeInAppWarning()" class="mt-8 text-sm text-slate-500 hover:text-white underline">
          ฉันเข้าใจแล้ว แต่ต้องการดำเนินการต่อ (อาจพบปัญหา)
      </button>
  </div>
}

<div class="flex items-center justify-center min-h-full p-4">
  <div class="w-full max-w-md">
    
    <!-- Title Section -->
    <div class="text-center mb-8">
      @if (isInvitationMode()) {
        <div class="inline-block p-3 rounded-full bg-emerald-900/50 mb-4 border border-emerald-500/30">
            <i class="fa-solid fa-envelope-open-text text-3xl text-emerald-400"></i>
        </div>
        <h1 class="text-3xl font-bold text-white mb-2">
          ตอบรับคำเชิญ
        </h1>
        <p class="text-slate-400 text-sm">คุณได้รับเชิญให้เข้าร่วมทีม กรุณาตั้งรหัสผ่านเพื่อเริ่มใช้งาน</p>
      } @else {
        <h1 class="text-3xl font-bold text-white">
          <i class="fa-solid fa-store mr-2 text-emerald-400"></i>
          เปิดร้านใหม่
        </h1>
        <p class="text-slate-400 mt-2">สร้างบัญชีเจ้าของร้านเพื่อเริ่มใช้งาน CHUAMKAN Platform</p>
      }
    </div>

    <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-8 border border-slate-700 relative overflow-hidden">
      
      @if(isInvitationMode()) {
          <div class="absolute top-0 left-0 right-0 h-1 bg-emerald-500"></div>
      }

      @switch (validationState()) {
        @case ('validating') {
          <div class="text-center py-10 text-slate-400">
            <i class="fa-solid fa-spinner animate-spin text-3xl mb-3 text-emerald-500"></i>
            <p>กำลังตรวจสอบความถูกต้องของลิงก์...</p>
          </div>
        }
        @case ('invalid') {
          <div class="text-center py-10 text-red-400">
            <i class="fa-solid fa-circle-xmark text-4xl mb-3"></i>
            <p class="font-bold text-lg">คำเชิญไม่ถูกต้องหรือหมดอายุ</p>
            <p class="text-sm mt-2 text-slate-400">{{ validationError() }}</p>
            <a routerLink="/login" class="mt-6 inline-block text-emerald-400 hover:text-emerald-300 underline">กลับไปหน้าล็อกอิน</a>
          </div>
        }
        @case ('valid') {
          
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <div class="space-y-4">
              
              <!-- NEW: Business Type Selection (Public registration only) -->
              @if(!isInvitationMode()) {
                <fieldset class="mb-4">
                    <legend class="block text-sm font-medium text-slate-300 mb-2">คุณคือ... (I am a...)</legend>
                    <div class="grid grid-cols-2 gap-3">
                        <label class="cursor-pointer group">
                            <input type="radio" formControlName="businessType" value="CLINIC" class="peer sr-only">
                            <div class="bg-slate-900 border-2 border-slate-600 rounded-lg p-3 text-center peer-checked:bg-blue-600 peer-checked:border-blue-500 hover:bg-slate-700 transition-all h-full flex flex-col justify-center items-center">
                                <i class="fa-solid fa-user-doctor text-3xl mb-2 text-slate-400 peer-checked:text-white group-hover:text-white transition-colors"></i>
                                <div class="text-sm font-bold text-white">คลินิก (Clinic)</div>
                                <div class="text-[10px] text-slate-400 mt-1 peer-checked:text-blue-100">ออกใบรับรองแพทย์</div>
                            </div>
                        </label>
                        <label class="cursor-pointer group">
                            <input type="radio" formControlName="businessType" value="DISPENSARY" class="peer sr-only">
                            <div class="bg-slate-900 border-2 border-slate-600 rounded-lg p-3 text-center peer-checked:bg-emerald-600 peer-checked:border-emerald-500 hover:bg-slate-700 transition-all h-full flex flex-col justify-center items-center">
                                <i class="fa-solid fa-cannabis text-3xl mb-2 text-slate-400 peer-checked:text-white group-hover:text-white transition-colors"></i>
                                <div class="text-sm font-bold text-white">ร้านยา (Dispensary)</div>
                                <div class="text-[10px] text-slate-400 mt-1 peer-checked:text-emerald-100">ต้องการเชื่อมต่อคลินิก</div>
                            </div>
                        </label>
                    </div>
                </fieldset>
              }

              <div>
                <label for="name" class="block text-sm font-medium text-slate-300 mb-1">ชื่อ-นามสกุล (Full Name)</label>
                <div class="relative">
                     <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                        <i class="fa-solid fa-user"></i>
                    </span>
                    <input formControlName="name" id="name" type="text" 
                    class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-3 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600" placeholder="เช่น สมชาย ใจดี">
                </div>
              </div>

              <div>
                <label for="email" class="block text-sm font-medium text-slate-300 mb-1">อีเมล (Email)</label>
                 <div class="relative">
                     <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                        <i class="fa-solid fa-envelope"></i>
                    </span>
                    <input formControlName="email" id="email" type="email" 
                    [class]="'w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-3 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600 ' + (isInvitationMode() ? 'bg-slate-700 text-slate-400 cursor-not-allowed opacity-70' : '')"
                    placeholder="name@example.com">
                </div>
                @if (isInvitationMode()) {
                  <p class="text-xs text-emerald-400/80 mt-1 flex items-center gap-1">
                      <i class="fa-solid fa-lock"></i> อีเมลถูกกำหนดโดยผู้เชิญ (แก้ไขไม่ได้)
                  </p>
                }
              </div>

              <div>
                <label for="password" class="block text-sm font-medium text-slate-300 mb-1">รหัสผ่าน (Password)</label>
                <div class="relative">
                     <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                        <i class="fa-solid fa-lock"></i>
                    </span>
                    <input 
                        [type]="showPassword() ? 'text' : 'password'"
                        formControlName="password" id="password" 
                        class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-10 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600" placeholder="••••••••">
                     <button type="button" (click)="togglePassword()" aria-label="Toggle password visibility" class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-500 hover:text-slate-300 focus:outline-none">
                        <i class="fa-solid" [class]="showPassword() ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                </div>
                <p class="text-xs text-slate-500 mt-1">ขั้นต่ำ 6 ตัวอักษร</p>
              </div>

              <div>
                <label for="confirmPassword" class="block text-sm font-medium text-slate-300 mb-1">ยืนยันรหัสผ่าน (Confirm Password)</label>
                <div class="relative">
                     <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                        <i class="fa-solid fa-lock"></i>
                    </span>
                    <input 
                        [type]="showConfirmPassword() ? 'text' : 'password'"
                        formControlName="confirmPassword" id="confirmPassword" 
                        class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-10 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600" placeholder="••••••••">
                    <button type="button" (click)="toggleConfirmPassword()" aria-label="Toggle confirm password visibility" class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-500 hover:text-slate-300 focus:outline-none">
                        <i class="fa-solid" [class]="showConfirmPassword() ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                </div>
                @if (registerForm.hasError('mismatch') && registerForm.get('confirmPassword')?.touched) {
                  <p class="text-red-400 text-xs mt-1">
                    รหัสผ่านไม่ตรงกัน
                  </p>
                }
              </div>

              @if (isInvitationMode()) {
                 <div>
                    <label for="pin" class="block text-sm font-medium text-slate-300 mb-1">ตั้งรหัส PIN 6 หลัก (Set PIN)</label>
                    <div class="relative">
                         <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                            <i class="fa-solid fa-keypad"></i>
                        </span>
                        <input formControlName="pin" id="pin" type="tel" maxlength="6"
                        class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-3 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600 tracking-widest font-mono" placeholder="------">
                    </div>
                    <p class="text-xs text-slate-500 mt-1">ใช้สำหรับเข้าสู่ระบบ Kiosk และ POS อย่างรวดเร็ว</p>
                    @if (registerForm.get('pin')?.touched && registerForm.get('pin')?.invalid) {
                         <p class="text-red-400 text-xs mt-1">กรุณากรอกตัวเลข 6 หลัก</p>
                    }
                  </div>
              }
              
              <!-- Legal Agreement Checkbox -->
              <div class="mt-4 p-3 bg-slate-900 rounded-lg border border-slate-600">
                <div class="flex items-start gap-3">
                   <div class="flex items-center h-5">
                      <input id="agreeTerms" type="checkbox" formControlName="agreeTerms" class="w-4 h-4 border border-gray-500 rounded bg-gray-700 focus:ring-3 focus:ring-emerald-500 focus:ring-offset-slate-900">
                   </div>
                   <label for="agreeTerms" class="text-xs font-medium text-slate-300">
                      ข้าพเจ้ายอมรับ <a (click)="openLegalModal('tos')" class="text-emerald-400 hover:underline cursor-pointer">ข้อกำหนดการให้บริการ</a> และ <a (click)="openLegalModal('privacy')" class="text-emerald-400 hover:underline cursor-pointer">นโยบายความเป็นส่วนตัว</a> ของแพลตฟอร์ม
                   </label>
                </div>
                @if (registerForm.get('agreeTerms')?.touched && registerForm.get('agreeTerms')?.invalid) {
                    <p class="text-red-400 text-xs mt-2 pl-7">กรุณายอมรับข้อตกลงเพื่อดำเนินการต่อ</p>
                }
              </div>

              @if (errorMessage()) {
                <div class="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg text-sm flex items-center gap-2">
                    <i class="fa-solid fa-circle-exclamation"></i> {{ errorMessage() }}
                </div>
              }
              @if (successMessage()) {
                <div class="bg-green-900/50 border border-green-700 text-green-300 px-4 py-3 rounded-lg text-sm flex items-center gap-2">
                     <i class="fa-solid fa-check-circle"></i> {{ successMessage() }}
                </div>
              }

              <button type="submit" [disabled]="registerForm.invalid || isLoading()"
                class="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-lg transition-colors disabled:bg-slate-600 disabled:cursor-not-allowed flex justify-center items-center gap-2 mt-6 shadow-lg shadow-emerald-900/20 active:scale-95 transform">
                @if (isLoading()) {
                  <i class="fa-solid fa-spinner animate-spin"></i>
                  <span>กำลังบันทึกข้อมูล...</span>
                } @else {
                   <span>
                    @if(isInvitationMode()) {
                      ลงทะเบียนและเข้าร่วมทีม
                    } @else {
                      สร้างบัญชีเจ้าของร้าน
                    }
                   </span>
                   <i class="fa-solid fa-arrow-right"></i>
                }
              </button>
            </div>
          </form>
        }
      }
    </div>

    <div class="text-center mt-6">
        <a routerLink="/login" class="text-sm text-emerald-400 hover:text-emerald-300 transition-colors">
            <i class="fa-solid fa-right-to-bracket"></i> มีบัญชีอยู่แล้ว? เข้าสู่ระบบ
        </a>
    </div>
  </div>
</div>

<!-- Legal Modal -->
<app-platform-legal-modal
  [isOpen]="isLegalModalOpen()"
  [initialTab]="legalModalTab()"
  (closeModal)="closeLegalModal()">
</app-platform-legal-modal>
